import CKEditor from '@ckeditor/ckeditor5-vue2'
import Vue from 'vue'

Vue.use(CKEditor)
